import React, { useEffect, useRef } from "react";

const TURNSTILE_SITE_KEY = "0x4AAAAAACqR5W629OFkRt19";

export default function TurnstileWidget({ onVerify }) {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useEffect(() => {
        const renderWidget = () => {
            if (window.turnstile && containerRef.current && widgetIdRef.current === null) {
                widgetIdRef.current = window.turnstile.render(containerRef.current, {
                    sitekey: TURNSTILE_SITE_KEY,
                    theme: "auto",
                    callback: (token) => onVerify(token),
                    "expired-callback": () => onVerify(""),
                    "error-callback": () => onVerify(""),
                });
            }
        };

        const existingScript = document.querySelector(
            'script[src*="challenges.cloudflare.com/turnstile"]'
        );

        if (!existingScript) {
            const script = document.createElement("script");
            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
            script.async = true;
            script.defer = true;
            script.onload = renderWidget;
            document.body.appendChild(script);
        } else {
            renderWidget();
        }

        return () => {
            if (window.turnstile && widgetIdRef.current !== null) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, [onVerify]);

    return <div ref={containerRef} style={{ margin: "16px 0" }} />;
}